import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import PrintSetNumber from './PrintSetNumber'
import { mobile } from '../../styles/media'

const AlternateSetNumbers = ({ highlight, language, print }) => {
	const hasAltSetNumbers = !!(!language && print.set.languages && print.set.languages.find(item => item.alternateSetNumber || item.alternateLanguageCode))

	return (
		<StyledAlternateSetNumbers>
			<AlternateSetNumber>
				<PrintSetNumber
					print={print}
					language={language}
					highlight={highlight}
				/>
			</AlternateSetNumber>
			{hasAltSetNumbers && (
				<AlternateSetNumber other>
					{print.set.languages.filter(item => item.alternateSetNumber).map(item => item.alternateSetNumber).join(', ')}
				</AlternateSetNumber>
			)}
		</StyledAlternateSetNumbers>
	)
}

AlternateSetNumbers.propTypes = {
	highlight: PropTypes.string,
	language: PropTypes.string,
	print: PropTypes.object.isRequired
}

AlternateSetNumbers.defaultProps = {
	highlight: null,
	language: null
}

export const StyledAlternateSetNumbers = styled.div`
	display: flex;
	gap: 0.25rem;
	flex-direction: column;

	font-family: ${props => props.theme.fontMonospace};
	font-size: 0.9rem;

	${mobile`
		font-size: 0.8rem;
	`}
`

const AlternateSetNumber = styled.div`
	white-space: nowrap;

	${props => props.other && `
		color: rgba(0, 0, 0, 0.3);
		font-family: ${props.theme.fontDefault};
		font-size: 0.7rem;
		font-style: italic;
		font-weight: 500;
	`}
`

export default AlternateSetNumbers
